import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

interface Props {
  title: string;
  onClick: () => void;
}

const SearchBar = (props: Props) => {
  const { title, onClick } = props;
  return (
    <SearchBarWrapper role='button' onClick={onClick}>
      <p>{title}</p>
      <MaterialIcon name='expand_more' size={24} color={theme.color.gray900} />
    </SearchBarWrapper>
  );
};

export default SearchBar;

const SearchBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 16px 12px;
  height: 48px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.gray40};
  cursor: pointer;
  & > p {
    ${({ theme }) => theme.typography.UI16R};
    color: ${({ theme }) => theme.color.gray900};
  }
`;
